import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-student-sign-photo-upload-report',
  templateUrl: './student-sign-photo-upload-report.component.html',
  styleUrls: ['./student-sign-photo-upload-report.component.scss']
})
export class StudentSignPhotoUploadReportComponent implements OnInit {
  studentDataForm: FormGroup;      
  UserCollege: any;
  userPermission: any;
  userId: number | null = null;
  collegeList: any[] = [];
  filteredCollegeList: any[] = [];
  CourseList: any[] = [];
  filteredCourseList: any[] = [];
  ExamAList: any[] = [];
  filteredExamAList: any[] = [];
  sessionList: any[] = [];
  SessionFilterList: any[] = [];

  selectedColleges: string[] = [];
  commaSeparatedColleges: string = '';

  selectedExams: string[] = [];
  commaSeparatedExams: string = '';

  reportData: any[] = [];
  isGenerating = false;

  selectedSessionName: string = '';
  selectedCourseName: string = '';
  selectedCollegeNames: string = '';
  selectedExamNames: string = '';
  totalStudents: number = 0;
  totalUploaded: number = 0;
  totalRemaining: number = 0;

  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.fetchSessions();

    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    this.userId = this.userPermission.length ? this.userPermission[0].UserId : null;
  }

  initializeForm(): void {
    this.studentDataForm = this.fb.group({
      Session: new FormControl('', Validators.required),
      course: new FormControl({ value: '', disabled: true }, Validators.required),
      college: new FormControl({ value: [], disabled: true }, Validators.required),
      Exam: new FormControl({ value: [], disabled: true }, Validators.required)
    });

    this.studentDataForm.get('Session').valueChanges.subscribe((value: string) => {
      if (value) {
        this.studentDataForm.get('course').enable();
        this.fetchCourses();
        this.resetDependentFields(['college', 'Exam']);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.selectedExams = [];
        this.commaSeparatedExams = '';
        this.selectedSessionName = this.getSessionName(value);
      } else {
        this.studentDataForm.get('course').disable();
        this.studentDataForm.get('college').disable();
        this.studentDataForm.get('Exam').disable();
        this.resetDependentFields(['course', 'college', 'Exam']);
        this.CourseList = [];
        this.filteredCourseList = [];
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.selectedColleges = [];
        this.selectedExams = [];
        this.selectedSessionName = '';
      }
    });

    this.studentDataForm.get('course').valueChanges.subscribe((value: string) => {
      if (value) {
        this.studentDataForm.get('college').enable();
        this.fetchColleges();
        this.resetDependentFields(['Exam']);
        this.selectedCourseName = this.getCourseName(value);
      } else {
        this.studentDataForm.get('college').disable();
        this.studentDataForm.get('college').setValue([]);
        this.resetDependentFields(['Exam']);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.selectedExams = [];
        this.commaSeparatedExams = '';
        this.selectedCourseName = '';
      }
    });

    this.studentDataForm.get('college').valueChanges.subscribe((value: string[]) => {
      if (value && value.length > 0) {
        this.studentDataForm.get('Exam').enable();
        this.fetchExams();
        this.selectedCollegeNames = value.map(code => this.getCollegeName(code)).join(', ');
      } else {
        this.studentDataForm.get('Exam').disable();
        this.studentDataForm.get('Exam').setValue([]);
        this.selectedExams = [];
        this.commaSeparatedExams = '';
        this.selectedCollegeNames = '';
      }
    });

    this.studentDataForm.get('Exam').valueChanges.subscribe((value: string[]) => {
      if (value && value.length > 0) {
        this.selectedExamNames = value.map(id => this.getExamName(id)).join(', ');
      } else {
        this.selectedExamNames = '';
      }
    });
  }

  fetchSessions(): void {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(
      (res) => {
        if (res.status) {
          this.sessionList = res.data.filter((item: any) => item.SnStatus === 'O');
          this.SessionFilterList = this.sessionList.slice();
        } else {
          this.sessionList = [];
          this.SessionFilterList = [];
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.error('Error fetching sessions:', error);
        this.spinner.hide();
      }
    );
  }

  fetchCourses(): void {
    const sessionId = this.studentDataForm.get('Session').value;
    if (!sessionId) return;

    this.spinner.show();
    const payload = { Session: sessionId };

    this.umsService.getSessionColgCo(payload).subscribe(
      (res) => {
        if (res.status) {
          const uniqueCourses = res.data.filter(
            (course: any, index: number, self: any[]) =>
              index === self.findIndex((c: any) => c.CoCgCoCode === course.CoCgCoCode)
          );
          this.CourseList = uniqueCourses;
          this.filteredCourseList = this.CourseList.slice();
          this.studentDataForm.get('course').setValue('');
        } else {
          this.CourseList = [];
          this.filteredCourseList = [];
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.error('Error fetching courses:', error);
        this.spinner.hide();
      }
    );
  }

  fetchColleges(): void {
    const sessionId = this.studentDataForm.get('Session').value;
    const courseCode = this.studentDataForm.get('course').value;
    if (!sessionId || !courseCode) return;

    this.spinner.show();

    this.UserCollege = this.userPermission[0]?.CgUi === 'C' ? this.userPermission[0].CgId : '';

    const payload = { CoCode: courseCode };

    this.umsService.fetchstucourseClgMap(payload).subscribe(
      (res) => {
        if (res.status && res.data) {
          this.collegeList = res.data;
          if (this.UserCollege) {
            this.collegeList = this.collegeList.filter(college => college.CgCode === this.UserCollege);
          }
          this.filteredCollegeList = this.collegeList.slice();
          this.selectedColleges = [];
          this.commaSeparatedColleges = '';
          this.studentDataForm.get('college').setValue([]);
          if (this.collegeList.length === 1) {
            this.selectedColleges = [this.collegeList[0].CgCode];
            this.commaSeparatedColleges = this.selectedColleges.join(',');
            this.studentDataForm.get('college').setValue(this.selectedColleges);
          }
        } else {
          this.collegeList = [];
          this.filteredCollegeList = [];
          this.selectedColleges = [];
          this.commaSeparatedColleges = '';
          this.studentDataForm.get('college').setValue([]);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.error('Error fetching colleges:', error);
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.studentDataForm.get('college').setValue([]);
        this.spinner.hide();
      }
    );
  }

  fetchExams(): void {
    const courseCode = this.studentDataForm.get('course').value;
    const sessionId = this.studentDataForm.get('Session').value;
    if (!courseCode || !sessionId) return;

    this.spinner.show();
    const payload = {
      EmCoCode: courseCode,
      SnNo: sessionId
    };

    this.umsService.getExam(payload).subscribe(
      (res) => {
        if (res.status && res.data && res.data.length > 0) {
          this.ExamAList = res.data;
          this.filteredExamAList = this.ExamAList.slice();
          this.studentDataForm.get('Exam').setValue([]);
        } else {
          this.ExamAList = [];
          this.filteredExamAList = [];
          this.studentDataForm.get('Exam').setValue([]);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.error('Error fetching exams:', error);
        this.ExamAList = [];
        this.filteredExamAList = [];
        this.studentDataForm.get('Exam').setValue([]);
        this.spinner.hide();
      }
    );
  }
  selectAllColleges(): void {
    if (this.isAllCollegesSelected()) {
      this.selectedColleges = [];
      this.studentDataForm.get('college').setValue([], { emitEvent: false });
      this.commaSeparatedColleges = '';
      this.studentDataForm.get('Exam').disable();
      this.studentDataForm.get('Exam').setValue([]);
      this.selectedExams = [];
      this.commaSeparatedExams = '';
    } else {
      this.selectedColleges = this.filteredCollegeList.map(item => item.CgCode);
      this.studentDataForm.get('college').setValue(this.selectedColleges, { emitEvent: false });
      this.commaSeparatedColleges = this.selectedColleges.join(',');
      this.studentDataForm.get('Exam').enable();
    }
  }

  onCollegeSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');

    this.selectedColleges = selected;
    this.studentDataForm.get('college').setValue(selected, { emitEvent: false });
    this.commaSeparatedColleges = this.selectedColleges.join(',');

    if (selected.length > 0) {
      this.studentDataForm.get('Exam').enable();
    } else {
      this.studentDataForm.get('Exam').disable();
      this.studentDataForm.get('Exam').setValue([]);
      this.selectedExams = [];
      this.commaSeparatedExams = '';
    }
  }

  isAllCollegesSelected(): boolean {
    return this.selectedColleges.length === this.filteredCollegeList.length && this.filteredCollegeList.length > 0;
  }

  isCollegeIndeterminate(): boolean {
    return this.selectedColleges.length > 0 && this.selectedColleges.length < this.filteredCollegeList.length;
  }

  selectAllExams(): void {
    if (this.isAllExamsSelected()) {
      this.selectedExams = [];
      this.studentDataForm.get('Exam').setValue([], { emitEvent: false });
      this.commaSeparatedExams = '';
    } else {
      this.selectedExams = this.filteredExamAList.map(item => item.EmId);
      this.studentDataForm.get('Exam').setValue(this.selectedExams, { emitEvent: false });
      this.commaSeparatedExams = this.selectedExams.join(',');
    }
  }

  onExamSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');

    this.selectedExams = selected;
    this.studentDataForm.get('Exam').setValue(selected, { emitEvent: false });
    this.commaSeparatedExams = this.selectedExams.join(',');
  }

  isAllExamsSelected(): boolean {
    return this.selectedExams.length === this.filteredExamAList.length && this.filteredExamAList.length > 0;
  }

  isExamIndeterminate(): boolean {
    return this.selectedExams.length > 0 && this.selectedExams.length < this.filteredExamAList.length;
  }

  canSelectExam(): boolean {
    const hasSession = !!this.studentDataForm.get('Session').value;
    const hasCourse = !!this.studentDataForm.get('course').value;
    const hasColleges = this.studentDataForm.get('college').value && this.studentDataForm.get('college').value.length > 0;
    return hasSession && hasCourse && hasColleges;
  }

  generateReport(): void {
    if (this.studentDataForm.invalid) {
      this.markFormGroupTouched(this.studentDataForm);
      return;
    }

    this.isGenerating = true;
    this.spinner.show();
    this.reportData = [];

    const formValue = this.studentDataForm.value;
    const collegeCodes = this.commaSeparatedColleges ||
      (Array.isArray(formValue.college) ? formValue.college.join(',') : formValue.college);
    const examIds = this.commaSeparatedExams ||
      (Array.isArray(formValue.Exam) ? formValue.Exam.join(',') : formValue.Exam);

    const payload = {
      Session: formValue.Session,
      CoCode: formValue.course,
      CgCode: collegeCodes,
      EmId: examIds
    };

    this.umsService.generateReport(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.isGenerating = false;
        if (res.status && res.data && res.data.length > 0) {
          this.reportData = res.data;
          this.calculateTotals();
        } else {
          this.reportData = [];
          this.resetTotals();
          this.openNoDataPopup(); 
        }
      },
      (error) => {
        this.spinner.hide();
        this.isGenerating = false;
        console.error('Error generating report:', error);
        this.reportData = [];
        this.resetTotals();
      }
    );
  }

  private openNoDataPopup(): void {
    const data = {
      message: 'No data available for the selected criteria.',
      title: 'Information',
      icon: 'fas fa-info-circle'
    };
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  private calculateTotals(): void {
    this.totalStudents = this.reportData.reduce((sum, item) => sum + (item.TotalStudents || 0), 0);
    this.totalUploaded = this.reportData.reduce((sum, item) => sum + (item.PhotoUploaded || 0), 0);
    this.totalRemaining = this.reportData.reduce((sum, item) => sum + (item.PhotoRemaining || 0), 0);
  }

  private resetTotals(): void {
    this.totalStudents = 0;
    this.totalUploaded = 0;
    this.totalRemaining = 0;
  }

  private resetDependentFields(fieldsToReset: string[]): void {
    fieldsToReset.forEach(field => {
      const control = this.studentDataForm.get(field);
      if (control) {
        control.setValue('');
        switch (field) {
          case 'course':
            this.CourseList = [];
            this.filteredCourseList = [];
            break;
          case 'college':
            this.selectedColleges = [];
            this.commaSeparatedColleges = '';
            this.collegeList = [];
            this.filteredCollegeList = [];
            break;
          case 'Exam':
            this.selectedExams = [];
            this.commaSeparatedExams = '';
            this.ExamAList = [];
            this.filteredExamAList = [];
            break;
        }
      }
    });
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getCollegeName(collegeCode: string): string {
    const college = this.collegeList.find(c => c.CgCode === collegeCode);
    return college ? college.CgName : collegeCode;
  }

  getCourseName(courseCode: string): string {
    const course = this.CourseList.find(c => c.CoCgCoCode === courseCode);
    return course ? course.CoName : courseCode;
  }

  getExamName(examId: string): string {
    const exam = this.ExamAList.find(e => e.EmId === examId);
    return exam ? exam.EmName : examId;
  }

  getSessionName(sessionId: string): string {
    const session = this.sessionList.find(s => s.SnNo === sessionId);
    return session ? session.SnName : sessionId;
  }

  reset(): void {
    this.studentDataForm.reset();
    this.CourseList = [];
    this.filteredCourseList = [];
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.ExamAList = [];
    this.filteredExamAList = [];
    this.selectedColleges = [];
    this.commaSeparatedColleges = '';
    this.selectedExams = [];
    this.commaSeparatedExams = '';
    this.selectedSessionName = '';
    this.selectedCourseName = '';
    this.selectedCollegeNames = '';
    this.selectedExamNames = '';

    this.reportData = [];
    this.totalStudents = 0;
    this.totalUploaded = 0;
    this.totalRemaining = 0;

    this.studentDataForm.get('course').disable();
    this.studentDataForm.get('college').disable();
    this.studentDataForm.get('Exam').disable();
    this.SessionFilterList = this.sessionList.slice();
  }
}